import * as React from "react";
import { forwardRef } from "react";
import { clsx } from 'clsx';
function _ArrowAltLeft(props, ref) {
    const { className, ...rest } = props;
    const classes = clsx('go-icon', className);
    return React.createElement("span", { className: classes, ref: ref, ...rest },
        React.createElement("svg", { width: "1em", height: "1em", fill: "none", viewBox: "0 0 24 24" },
            React.createElement("path", { fill: "currentColor", d: "m5 12-.707-.707-.707.707.707.707zm12 1a1 1 0 1 0 0-2zM8.293 7.293l-4 4 1.414 1.414 4-4zm-4 5.414 4 4 1.414-1.414-4-4zM5 13h12v-2H5z" })));
}
const ArrowAltLeft = forwardRef(_ArrowAltLeft);
export { ArrowAltLeft };
